"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sagaError;
exports.SAGA_ERROR = void 0;
var SAGA_ERROR = 'WEB_CHAT/SAGA_ERROR';
exports.SAGA_ERROR = SAGA_ERROR;

function sagaError() {
  return {
    type: SAGA_ERROR
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NhZ2FFcnJvci5qcyJdLCJuYW1lcyI6WyJTQUdBX0VSUk9SIiwic2FnYUVycm9yIiwidHlwZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLFVBQVUsR0FBRyxxQkFBbkI7OztBQUVlLFNBQVNDLFNBQVQsR0FBcUI7QUFDbEMsU0FBTztBQUNMQyxJQUFBQSxJQUFJLEVBQUVGO0FBREQsR0FBUDtBQUdEIiwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0FHQV9FUlJPUiA9ICdXRUJfQ0hBVC9TQUdBX0VSUk9SJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2FnYUVycm9yKCkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFNBR0FfRVJST1JcbiAgfTtcbn1cblxuZXhwb3J0IHsgU0FHQV9FUlJPUiB9O1xuIl19